import { Field, FieldProps } from 'formik';
import React, { ReactNode } from 'react';
import { InjectedIntl, injectIntl } from 'react-intl';
import InputField from '../components/InputField';
import ValidationErrors from './validationErrors';
import ValueFormatters from './valueFormatters';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import { ValidatorRule } from '../validator/validatorRule.constants';
import { CompanyNameFieldValidator } from '../validator/companyNameFieldValidator';
import { IErrorMessage } from '../components/errorMessage/errorMessage.type';

interface ICompanyNameFieldProps {
    autoFocus?: boolean;
    intl: InjectedIntl;
    value?: string;
    required?: boolean;
    validatorRules?: ValidatorRule[];
}

class CompanyNameField extends React.Component<ICompanyNameFieldProps> {
    private readonly ID: string;
    private readonly LABEL_ID: string;
    private readonly MAX_LENGTH: number;

    private companyNameFieldValidator: CompanyNameFieldValidator;

    constructor(props: ICompanyNameFieldProps) {
        super(props);

        this.ID = 'companyName';
        this.LABEL_ID = 'label.company_name';
        this.MAX_LENGTH = 255;

        this.validate = this.validate.bind(this);
        this.renderInputField = this.renderInputField.bind(this);

        const { validatorRules = [ValidatorRule.EUCompanyLengthRule] } = props;
        this.companyNameFieldValidator = new CompanyNameFieldValidator(validatorRules);
    }

    public render() {
        return <Field name={this.ID} validate={this.validate} render={this.renderInputField} />;
    }

    private validate(value: string): IErrorMessage {
        const { intl, required } = this.props;

        if (!value && required) {
            return ValidationErrors.fieldRequiredMessage(intl, this.LABEL_ID);
        }

        let errorMessage: IErrorMessage = '';
        if (value) {
            const err = this.companyNameFieldValidator.validate(value, this.LABEL_ID);
            if (err !== null) {
                errorMessage = err.message;
            }
        }

        return errorMessage;
    }

    private renderInputField({
        field,
        form: { touched, errors, setFieldValue, handleBlur },
    }: FieldProps): ReactNode {
        const { autoFocus, value, required } = this.props;
        const isTouched = touched && touched[this.ID];
        const errorMessage = isTouched && errors && errors[this.ID] ? errors[this.ID] : undefined;
        const onBlur = (event: React.FocusEvent<any>) => {
            setFieldValue(this.ID, ValueFormatters.trimExtraSpaces(event.target.value));
            handleBlur(event);
        };

        return (
            <InputField
                autoComplete="organization"
                labelMessage={TranslationHelpers.getMessageDescriptor(this.LABEL_ID)}
                type="text"
                id={this.ID}
                maxLength={this.MAX_LENGTH}
                name={this.ID}
                value={value}
                error={errorMessage}
                autoFocus={autoFocus}
                required={required}
                onBlur={onBlur}
            />
        );
    }
}

export default injectIntl(CompanyNameField);
